import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { AccountPage } from '../pages/account-page';
import { AuthenticatedEmployeeRoute } from '../pages/authenticated-employee-route';
import { CongratsPage } from '../pages/congrats-page';
import { GoalPage } from '../pages/goal-page';
import { HomePage } from '../pages/home-page';
import { IndexPage } from '../pages/index-page';
import { LoginPage } from '../pages/login-page';
import { MyPage } from '../pages/my-page';
import { MyPageLanguagePage } from '../pages/my-page-language-page';
import { MyPagePinPage } from '../pages/my-page-pin-page';
import { MyPageProfilePage } from '../pages/my-page-profile-page';
import { MyPageSecurityPage } from '../pages/my-page-security-page';
import { OnboardingPage } from '../pages/onboarding-page';
import { PersonalDataPage } from '../pages/personal-data-page';
import { PhotoPage } from '../pages/photo-page';
import { PhotoReviewPage } from '../pages/photo-review-page';
import { ReferralAttributionRouteObserver } from '../pages/referral-attribution-route-observer';
import { ReferralPage } from '../pages/referral-page';
import { ReferralRaffleProfessionalPage } from '../pages/referral-raffle-professional-page';
import { RegistrationEmailPage } from '../pages/registration-email-page';
import { RegistrationLayout } from '../pages/registration-layout';
import { SessionUnlockPage } from '../pages/session-unlock-page';
import { StatementPage } from '../pages/statement-page';
import { TipPage } from '../pages/tip-page';
import { TipThanksPage } from '../pages/tip-thanks-page';
import { ValuePage } from '../pages/value-page';
import { VerifyPage } from '../pages/verify-page';
import { WithdrawalAmountPage } from '../pages/withdrawal-amount-page';
import { WithdrawalPage } from '../pages/withdrawal-page';

export function AppRoutes() {
  const basename =
    import.meta.env.BASE_URL === '/'
      ? undefined
      : import.meta.env.BASE_URL.replace(/\/$/, '');

  return (
    <BrowserRouter basename={basename}>
      <ReferralAttributionRouteObserver />
      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/unlock" element={<SessionUnlockPage />} />
        <Route element={<AuthenticatedEmployeeRoute />}>
          <Route path="/settings" element={<AccountPage />} />
          <Route path="/settings/security" element={<MyPageSecurityPage />} />
          <Route
            path="/settings/personal-data"
            element={<MyPageProfilePage />}
          />
          <Route path="/settings/pin" element={<MyPagePinPage />} />
          <Route path="/settings/language" element={<MyPageLanguagePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/my-page" element={<MyPage />} />
          <Route path="/referral" element={<ReferralPage />} />
          <Route
            path="/referral/raffle/professional"
            element={<ReferralRaffleProfessionalPage />}
          />
          <Route path="/statement" element={<StatementPage />} />
          <Route path="/withdrawal" element={<WithdrawalPage />} />
          <Route path="/withdrawal/amount" element={<WithdrawalAmountPage />} />
        </Route>
        <Route path="/tip" element={<Navigate replace to="/home" />} />
        <Route path="/tip/:walletUUID" element={<TipPage />} />
        <Route path="/tip/thanks" element={<Navigate replace to="/home" />} />
        <Route path="/tip/:walletUUID/thanks" element={<TipThanksPage />} />
        <Route path="/registration" element={<RegistrationLayout />}>
          <Route index element={<IndexPage />} />
          <Route path="onboarding" element={<OnboardingPage />} />
          <Route path="email" element={<RegistrationEmailPage />} />
          <Route path="personal-data" element={<PersonalDataPage />} />
          <Route path="photo" element={<PhotoPage />} />
          <Route path="photo/review" element={<PhotoReviewPage />} />
          <Route path="goal" element={<GoalPage />} />
          <Route path="value" element={<ValuePage />} />
          <Route path="congrats" element={<CongratsPage />} />
          <Route
            path="card"
            element={
              <Navigate replace to="/registration/congrats?state=card" />
            }
          />
        </Route>
        <Route path="/verify" element={<VerifyPage />} />
      </Routes>
    </BrowserRouter>
  );
}
